import React, { Component } from 'react';
import logo from './logo.svg';
import underline from './underline.svg';
import './App.css';
import { Navbar, Nav, NavItem, Row, Col, FormGroup, FormControl, Button, ControlLabel } from 'react-bootstrap';

class App extends Component {
  render() {
    return (
      <div>
        <Navbar fixedTop>
          <Navbar.Header>
            <Navbar.Brand>
              <a href="#" className="pull-left"><img src={logo} className="logo"/></a>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Navbar.Text>Proteolux</Navbar.Text>
            <Nav pullRight>
              <NavItem eventKey={1} href="#home">Home</NavItem>
              <NavItem eventKey={2} href="#about">About Us</NavItem>
              <NavItem eventKey={3} href="#projects">Projects</NavItem>
              <NavItem eventKey={4} href="#contact">Contact</NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

      <Row id="home">
        <Col xs={6} md={6} className='landingpgleft' style={{paddingTop: 35 + 'vh'}}>
          <h1 className='slideUp'>proteo</h1>
          <h3 className='slideUp'>Software</h3>
        </Col>
        <Col xs={6} md={6} className='imgcontainer landingpgright' style={{paddingTop: 35 + 'vh', paddingBottom: 8 + 'rem'}}>
          <h1 className='slideUp'>lux</h1>
          <h3 className='slideUp'>& Design</h3>
          <Button className="splash-button slideRight" href="#about">See How It Works</Button>
        </Col>
      </Row>

      <Row id="about">
        <Row className='bannerimg'>
        </Row>
        <Row className='introbox'>
          <h2>Our products</h2>
          <img src={underline}/>
          <p>Launched in 2017, Proteolux&apos;s first project (proteoplus) was to develop a cleaner user-interface for molecular scientists to conduct
          and automate experimental planning. Since then, Proteolux has developed other in-house products in the space of biotech and education. Our team
          is passionate about designing great user experiences and creating well-written software, especially with our expertise in the field of
          biotech.
          </p>

          <div style={{textAlign: 'right'}}>
            <h2>Making software simpler, more user friendly, and more efficient.</h2>
            <img src={underline}/>
            <p>At Proteolux, we’re building the platforms that integrate good design with technology needs.
                We offer consulting and technical help for companies looking to improve or build out their software products.
            </p>

          </div>
        </Row>
      </Row>

      <Row id="projects" className='projectscontainer' style={{marginTop: -3 + 'rem'}}>
        <h1>What We&apos;re Working On</h1>
        <Col xs={12} md={4}>
          <h4>Proteoplus</h4>
          <p>Proteoplus is a set of computational tools to help Molecular Assessment scientists conduct their mass spectrometry work
          quickly. The software automates experimental set up as well as report building, once the scientific experiments are conducted.
          </p>
        </Col>
        <Col xs={12} md={4}>
          <h4>TadSchool</h4>
          <p>Tadschool is a educational technology platform currently with a specific focus on biology and chemistry education.
          Tadschool uses animations and clean user interfaces to help students with understanding complex materials in bio or chemistry courses.
          </p>
        </Col>
        <Col xs={12} md={4}>
          <h4>UCSF</h4>
          <p>One of our consultants has been working on developing an iOS application for UCSF Dental school for a connected digital health platform.</p>
        </Col>
      </Row>

      <Row id="contact">
        <Col xs={12} md={6}>
          <form action="https://formspree.io/matt@proteolux.com" method="POST"
                style={{padding: '13rem 3rem'}}>
            <FormGroup>
              <ControlLabel style={{fontWeight: 'bold'}}>YOUR NAME.</ControlLabel>
              <FormControl type="text" name="name"/>
            </FormGroup>
            <FormGroup>
              <ControlLabel style={{fontWeight: 'bold'}}>YOUR EMAIL.</ControlLabel>
              <FormControl type="email" name="_replyto"/>
            </FormGroup>
            <FormGroup>
              <ControlLabel style={{fontWeight: 'bold'}}>YOUR MESSAGE.</ControlLabel>
              <FormControl componentClass="textarea" name="messagebody"/>
            </FormGroup>
            <Button bsStyle="success" type="submit">Let&apos;s Talk.</Button>
          </form>
        </Col>
        <Col xs={12} md={6}>
          <h1 className='headline slideLeft'>If you are interested in getting consulting help or collaborating, we&apos;d love to hear from you!</h1>
        </Col>
      </Row>

      <Row className="footer">
        <p>Copyright © 2018 Proteolux, LLC</p>
      </Row>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js